// In Next.js, this file would be called: app/providers.jsx
'use client';

import { queryClient } from '@/lib/query-client';
import { TooltipProvider } from '@/components/ui/tooltip';
// Since QueryClientProvider relies on useContext under the hood, we have to put 'use client' on top
import { QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import { URLSearchProvider } from '@/components/url-search-wrapper';
import { usePathname } from 'next/navigation';

export default function Providers({ children }: { children: React.ReactNode }) {
  const [qc] = useState(() => queryClient);
  const pathname = usePathname();
  return (
    <QueryClientProvider client={qc}>
      <NuqsAdapter>
        <URLSearchProvider key={pathname}>
          <TooltipProvider>{children}</TooltipProvider>
        </URLSearchProvider>
      </NuqsAdapter>
    </QueryClientProvider>
  );
}
